import { render, staticRenderFns } from "./consignmentReportList.vue?vue&type=template&id=6eb6750e"
import script from "./consignmentReportList.vue?vue&type=script&lang=js"
export * from "./consignmentReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports